import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/auth/directive.vue
 */

export function filterRoutes(router) {
    let routerAuth = store.getters && store.getters.routerAuth;
    let toRouter = [router]
    let hasPermission = routerAuth.some(role => {
        return toRouter.includes(role.href)
    })

    if (!hasPermission) {
        return false
    }
    return true
}
export function checkPermission(value) {
    if (value && value instanceof Array && value.length > 0) {
        // const roles = store.getters && store.getters.roles
        const menuAuth = store.getters && store.getters.menuAuth;
        const routerAuth = store.getters && store.getters.routerAuth;
        const buttonAuth = store.getters && store.getters.buttonAuth;
        // console.log(menuAuth)
        // console.log(routerAuth)
        // console.log(buttonAuth)
        buttonAuth.forEach(item => {
            // console.log(item.permission)
        })
        const permissionRoles = value;
        if (permissionRoles[0] == 'menu') { //当前进行的是菜单权限的校验；
            let hasPermission = menuAuth.some(role => {
                return permissionRoles.includes(role.name)
            })

            if (!hasPermission) {
                return false
            }
            return true
        } else if (permissionRoles[0] == 'router') { //当前进行的是路由权限的校验；
            let hasPermission = routerAuth.some(role => {
                return permissionRoles.includes(role.name)
            })

            if (!hasPermission) {
                return false
            }
            return true

        } else if (permissionRoles[0] == 'button') { //当前进行的是按钮权限的校验；
            let hasPermission = buttonAuth.some(role => {
                return permissionRoles.includes(role.permission)
            })

            if (!hasPermission) {
                return false
            }
            return true
        } else {
            console.error(`参数传入错误，请按照如下格式书写：checkPermission(['router','公海'])`)
            return false
        }

    } else {
        console.error(`缺少参数，请按照如下格式书写：checkPermission(['router','公海'])`)
        return false
    }
}


// WEBPACK FOOTER //
// ./src/utils/permission.js